// Ported from EnterpriseTemplates react-project-template (Release 1.3.1), PMS slice 4b.
// Catalog screen ORG_FINANCIAL_YEAR (database-template seed/026).
import React from 'react';
import { OrganisationMasterScreen } from '../OrganisationMasterScreen';
import { financialYearDefinition } from '../organisationDefinitions';

const FinancialYearMasterScreen: React.FC<{ moduleIcon?: string; tabId?: string; moduleName?: string; allowedActions?: string[] }> = (props) => (
  <OrganisationMasterScreen definition={financialYearDefinition} {...props} />
);

export default FinancialYearMasterScreen;
